<nz-spin [nzSpinning]="isLoading" [nzSize]="'large'" [nzTip]="loadingMessage" style="min-height: 200px; padding: 10px;">
  <div class="payroll-container">
    <div class="payroll-controls">
      <nz-form-item>
        <nz-form-label>Date Range</nz-form-label>
        <nz-form-control>
          <nz-range-picker [(ngModel)]="dateRange"></nz-range-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Pay Date</nz-form-label>
        <nz-form-control>
          <nz-date-picker [(ngModel)]="payDate"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <button nz-button nzType="primary" (click)="calculatePayroll()" [nzLoading]="calculating">
        Calculate Payroll
      </button>
    </div>

    <!-- Results Drawer -->
    <nz-drawer [nzVisible]="showResults" [nzTitle]="drawerTitle" (nzOnClose)="showResults = false" [nzWidth]="720">
      <ng-template #drawerTitle>
        Payroll Results: {{ cycle_holder_startDate | date }} - {{ cycle_holder_endDate | date }}
      </ng-template>
      <ng-container *nzDrawerContent>
        <nz-collapse>
          <nz-collapse-panel *ngFor="let userResult of results" [nzHeader]="userPanelHeader" [nzActive]="false">
            <ng-template #userPanelHeader>
              <div class="panel-header">
                <span>{{ userResult.userName }} - </span>
                <span class="panel-total">{{ userResult.totalCommission | currency }}</span>
              </div>
            </ng-template>

            <nz-table [nzData]="userResult.customers" [nzPageSize]="10" nzShowPagination="true" nzShowSizeChanger="true"
              [nzPageSizeOptions]="['10', '20', '50']">
              <thead>
  <tr>
    <th nzWidth="56px"></th>
    <th nzShowSort nzSortKey="customerName">Customer Name</th>
    <th nzShowSort nzSortKey="commission">Commission</th>
    <th nzShowSort nzSortKey="totalPaidAllTime">Total Paid All Time</th>
    <th>Original Sales Rep</th>
    <th>Pay Type</th>
    <th>Status</th>
    <th>Actions</th>
  </tr>
</thead>
              <tbody>
                <tr *ngFor="let customer of userResult.customers" class="customer-detail-row">
                  <td></td> <!-- Empty column where expand button was -->
                  <td>{{ customer.customerName }}</td>
                  <td>{{ customer.commission | currency }}</td>
                  <td>
                    <span 
                      class="clickable-amount" 
                      (click)="showCustomerPayHistoryBreakdown(customer.customerId, customer.customerName)"
                      title="Click to see payment history breakdown">
                      {{ customer.totalPaidAllTime | currency }}
                    </span>
                  </td>
                  <td>{{ customer.originalSalesRep || customer.salesRep }}</td>
                  <td>
                    <nz-tag [nzColor]="getPayTypeColor(customer.payType)">
                      {{ getPayTypeDisplay(customer.payType) }}
                    </nz-tag>
                  </td>
                  <td>
                    <nz-tag [nzColor]="customer.status === 'paid' ? 'green' : 'gold'">
                      {{ customer.status | titlecase }}
                    </nz-tag>
                    <nz-tag *ngIf="customer.wasAdjusted" nzColor="warning">
                      Adjusted from {{ customer.originalCommission | currency }}
                    </nz-tag>
                    <nz-tag *ngIf="customer.isAdjustment" nzColor="orange">Adjustment</nz-tag>
                    <nz-tag *ngIf="customer.isCompanyPayment" nzColor="purple">Company Payment</nz-tag>
                  </td>
                  <td>
                    <button nz-button nzType="link" (click)="showCustomerPayHistoryBreakdown(customer.customerId, customer.customerName)"
                            *ngIf="customer.customerId && !customer.customerId.startsWith('customer-')">
                      View History
                    </button>
                    <button nz-button nzType="link" *ngIf="canManageHoldbacks()"
                      (click)="openDeductModal(userResult.userId)">
                      Deduct from Holdback
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </nz-collapse-panel>
        </nz-collapse>

        <div class="total-section">
          <h2>Grand Total: {{ getGrandTotal() | currency }}</h2>
          <div class="button-group">
            <button nz-button nzType="primary" (click)="savePayrollCycle()" [disabled]="!payDate">
              Save Payroll Cycle
            </button>
            <button nz-button (click)="exportToCSV()" [nzType]="'default'">
              Export to CSV
            </button>
          </div>
        </div>
      </ng-container>
    </nz-drawer>

    <!-- Payroll History -->
    <nz-divider></nz-divider>
    <h2>Payroll History</h2>

    <nz-table [nzData]="groupedPayrollHistory">
      <thead>
        <tr>
          <th>Pay Date</th>
          <th>Total Amount</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let group of groupedPayrollHistory">
          <td>{{ group.payDate | date: 'mediumDate' }}</td>
          <td>{{ group.totalAmount | currency }}</td>
          <td>
            <nz-tag [nzColor]="getGroupStatusColor(group.status)">
              {{ group.status }}
            </nz-tag>
          </td>
          <td>
            <button nz-button nzType="primary" *ngIf="group.status === 'pending'" (click)="markGroupAsPaid(group)">
              Mark as Paid
            </button>
            <button nz-button nzType="default" nzDanger *ngIf="group.status === 'paid' && isMe()"
              (click)="markGroupAsUnpaid(group)">
              Revert to pending
            </button>
            <button nz-button (click)="viewGroupDetails(group)" [nzLoading]="isGroupLoading(group.id)">
              View Details
            </button>
            <button nz-button (click)="exportGroupToCSV(group)">
              Export
            </button>
            <button nz-button nzDanger *ngIf="group.status === 'pending'" (click)="deleteGroupCycles(group)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

<nz-modal [(nzVisible)]="showDeductModal" nzTitle="Deduct From Holdback" (nzOnCancel)="showDeductModal = false"
  (nzOnOk)="submitDeduction()">
  <ng-container *nzModalContent>
    <div style="display:flex; gap:12px; align-items:center;">
      <nz-input-group nzAddOnBefore="Amount">
        <input nz-input type="number" min="0" [(ngModel)]="deductAmount" />
      </nz-input-group>
    </div>
    <div style="margin-top:10px;">
      <nz-input-group nzAddOnBefore="Reason">
        <input nz-input [(ngModel)]="deductReason" placeholder="e.g., Equipment charge" />
      </nz-input-group>
    </div>
    <div style="margin-top:10px;">
      <textarea nz-input rows="3" [(ngModel)]="deductNotes" placeholder="Notes (optional)"></textarea>
    </div>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="showCustomerHistoryModal" [nzTitle]="'Commission History for ' + selectedCustomerName"
  (nzOnCancel)="closeCustomerHistory()" [nzFooter]="null" [nzWidth]="800">
  <ng-container *nzModalContent>
    <nz-table [nzData]="customerHistory" [nzPageSize]="10" nzShowPagination="true" nzShowSizeChanger="true"
      [nzPageSizeOptions]="['5', '10', '20']">
      <thead>
        <tr>
          <th>Date Paid</th>
          <th>Amount</th>
          <th>Sales Rep</th>
          <th>Pay Cycle</th>
          <th>Status</th>
          <th>Work Order</th>
          <th>Order Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let history of customerHistory" [ngClass]="{'pending-row': history.status === 'Pending'}">
          <td>
            <span *ngIf="history.datePaid; else pendingDate">
              {{ history.datePaid | date }}
            </span>
            <ng-template #pendingDate>
              <nz-tag nzColor="gold">Pending</nz-tag>
            </ng-template>
          </td>
          <td>{{ history.amount | currency }}</td>
          <td>{{ history.userName }}</td>
          <td>{{ history.cycleDateRange }}</td>
          <td>
            <nz-tag [nzColor]="history.status === 'Paid' ? 'green' : 'gold'">
              {{ history.status }}
            </nz-tag>
          </td>
          <td>{{ history.workOrderId }}</td>
          <td>{{ history.orderType }}</td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>

<!-- Customer Pay History Breakdown Modal -->
<nz-modal 
  [(nzVisible)]="showCustomerPayHistoryModal" 
  [nzTitle]="'Payment History Breakdown for ' + selectedCustomerForPayHistory"
  (nzOnCancel)="closeCustomerPayHistory()" 
  [nzFooter]="null" 
  [nzWidth]="1000">
  <ng-container *nzModalContent>
    <div *ngIf="selectedCustomerPayHistory.length === 0" class="text-center p-4">
      <nz-empty nzNotFoundContent="No payment history found"></nz-empty>
    </div>
    
    <nz-table 
      *ngIf="selectedCustomerPayHistory.length > 0"
      [nzData]="selectedCustomerPayHistory" 
      [nzPageSize]="10" 
      nzShowPagination="true" 
      nzShowSizeChanger="true"
      [nzPageSizeOptions]="['5', '10', '20']">
      <thead>
        <tr>
          <th>Pay Date</th>
          <th>Amount</th>
          <th>Pay Type</th>
          <th>Payee</th>
          <th>Original Sales Rep</th>
          <th>Cycle Period</th>
          <th>Status</th>
          <th>Work Order</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let payment of selectedCustomerPayHistory">
          <td>{{ payment.payDate | date }}</td>
          <td>{{ payment.amount | currency }}</td>
          <td>
            <nz-tag [nzColor]="getPayTypeColor(payment.payType)">
              {{ getPayTypeDisplay(payment.payType) }}
            </nz-tag>
          </td>
          <td>{{ payment.payeeName }}</td>
          <td>{{ payment.originalSalesRep }}</td>
          <td>
            {{ payment.cycleStartDate | date:'shortDate' }} - 
            {{ payment.cycleEndDate | date:'shortDate' }}
          </td>
          <td>
            <nz-tag [nzColor]="payment.cycleStatus === 'paid' ? 'green' : 'gold'">
              {{ payment.cycleStatus | titlecase }}
            </nz-tag>
          </td>
          <td>{{ payment.workOrderId || 'N/A' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td><strong>Total:</strong></td>
          <td><strong>{{ getCustomerPayHistoryTotal() | currency }}</strong></td>
          <td colspan="6"></td>
        </tr>
      </tfoot>
    </nz-table>
  </ng-container>
</nz-modal>